import moment from "moment-timezone";

if (window.timezone) {
    moment.tz.setDefault(window.timezone);
} else {
    moment.tz.setDefault(moment.tz.guess());
}
